/* eslint-disable react/react-in-jsx-scope */
import { Card, ThemeProvider } from '@veneer/core';

import { HowYourPlanWorksCardType } from './types';
import {
  CardAction,
  CardAnchor,
  CardDescription,
  Content,
  Image,
  CardTitle,
} from './styles';

export const PlanCard = ({
  cardData,
  onActionClick,
}: {
  cardData: HowYourPlanWorksCardType;
  onActionClick?: (actionName: string) => void;
}) => {
  const handleActionClick = (actionName: string) => {
    onActionClick?.(actionName);
  };

  const renderCardAction = (action: HowYourPlanWorksCardType['action']) => {
    if (!action) return null;

    if (action.url) {
      return (
        <CardAnchor
          href={action.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleActionClick(action.name)}
        >
          {action.text}
        </CardAnchor>
      );
    }

    return (
      <CardAction onClick={() => handleActionClick(action.name)}>
        {action.text}
      </CardAction>
    );
  };

  return (
    <ThemeProvider shape="round">
      <Card border="none" style={{ height: '100%' }}>
        <Image src={cardData.image.src} alt={cardData.image.alt} />
        <Content>
          <CardTitle>{cardData.title}</CardTitle>
          {cardData.description.map((desc: string) => (
            <CardDescription key={desc}>{desc}</CardDescription>
          ))}

          {cardData.action && renderCardAction(cardData.action)}
        </Content>
      </Card>
    </ThemeProvider>
  );
};
